import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const WritingPage = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-798" data-mp="1o2ynvxo4ie58">
      <Header data-id="element-799" data-mp="2brhum8riyiv7" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-800" data-mp="2bst2ajo3carl">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-801" data-mp="2ftbrs72ih4qm">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-802" data-mp="2fvftqjgunto9">
            <Navigation data-id="element-803" data-mp="220vn71tyoynl" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-804" data-mp="21zu90ohnfw1n">
            <div className="max-w-2xl" data-id="element-805" data-mp="2708b7pwkkbrr">
              <ul className="list-none leading-tight" data-id="element-806" data-mp="26yx3xg3x0lvw">
                <li className="mb-[0.2rem]" data-id="element-807" data-mp="2uqce1v1xo7hp">
                  <Link to="/motherhood-story" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-808" data-mp="2uoj4a6w0x75h">
                    Motherhood Story (<em data-id="element-809" data-mp="2v3mh8ul84ub3">The Fourth Magazine</em>, 2026)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-810" data-mp="39s0nlfhun0we">
                  <Link to="/madonna-child" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-811" data-mp="39qpi9b8r9l36">
                    Madonna & Child (<em data-id="element-812" data-mp="1ogr06uf6d9ny">Badlon Magazine</em>, 2025)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-813" data-mp="1ji7e8u0kzxvl">
                  <Link to="/giovannitti-needs-god" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-814" data-mp="3jivw0yooctju">
                    Giovannitti Needs God (Interview, <em data-id="element-815" data-mp="69q1f3naitoa">Badlon Magazine</em>{' '}
                    2025)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-816" data-mp="g1m0agx7antk">
                  <a href="https://blog.photoeye.com/2025/04/emerald-drifters-reviewed-by-madeleine.html" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-817" data-mp="g2otivhzx2cn">
                    Emerald Drifters (Review, <em data-id="element-818" data-mp="25jiwahum3s3j">Photo-Eye</em> 2025)
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WritingPage;